import { useEffect, useState } from "react";
import { Typography, Tag, Empty, Button, Flex } from "antd";
import { sellBoostFetch } from "../../utlifyFunction";
import CustomTable from "../../components/Table/CustomTable";
import PrimaryButton from "../../components/Buttons/PrimaryButton";
import { useNavigate } from "react-router-dom";
const { Title, Paragraph } = Typography;

const BulkUpdatePage = ({ generateDescriptions = null }) => {
	const [orderData, setOrderData] = useState(null);

	const navigate = useNavigate();
	const columns = [
		{
			title: "Order Status",
			dataIndex: "orderStatus",
			key: "orderStatus",
			render: (status) => {
				let color;
				switch (status) {
					case 1:
						color = "blue";
						break;
					case 2:
						color = "gold";
						break;
					case 3:
						color = "cyan";
						break;
					case 4:
						color = "geekblue";
						break;
					case 5:
						color = "magenta";
						break;
					default:
						color = "default";
				}
				return <Tag color={color}>{statusMap[status]}</Tag>;
			},
		},
		{
			title: "Created At",
			dataIndex: "createdAt",
			key: "createdAt",
			render: (createdAt) => {
				const date = new Date(createdAt);
				const formattedDate = date.toLocaleDateString("en-US", {
					year: "numeric",
					month: "short",
					day: "numeric",
					hour: "2-digit",
					minute: "2-digit",
				});
				return <span style={{ color: "#666" }}>{formattedDate}</span>;
			},
		},
		{
			title: "Product Count",
			dataIndex: "productCount",
			key: "productCount",
			render: (count) => <span style={{ fontWeight: "500" }}>{count}</span>,
		},
		{
			title: "Action",
			key: "action",
			width: "60px",
			render: (_, record) => (
				<PrimaryButton type="primary" height={"30px"} onClick={() => navigate(`/bulk-AI-generation/order/${record.orderId}`)}>
					View Order
				</PrimaryButton>
			),
		},
	];

	const fetchOrders = async () => {
		const data = await sellBoostFetch("GET", "/user/order-data");
		setOrderData(data?.orders || []);
	};

	useEffect(() => {
		fetchOrders();
	}, []);

	const NoDataComponent = () => (
		<div style={{ textAlign: "center", padding: "40px" }}>
			<Empty description={false} />
			<Paragraph style={{ color: "#666", fontSize: "14px", marginTop: "8px" }}>
				No bulk update orders found. Create a new order to update multiple
				products at once.
			</Paragraph>
			<Button
				type="primary"
				style={{
					background: "#6D5BBA",
					borderRadius: "8px",
					fontWeight: 500,
					marginTop: "12px",
				}}
				onClick={() => navigate("/bulk-AI-generation/create-order")}
			>
				+ Create New Order
			</Button>
		</div>
	);

	return (
		<div style={{ padding: "24px" }}>
			<Flex justify="space-between" align="center">
				<Title level={4} style={{ margin: "10px 0px" }}>
					Bulk Update
				</Title>
				{orderData?.length>0&&<PrimaryButton
					type="primary"
					height={"30px"}
					onClick={() => navigate("/bulk-AI-generation/create-order")}
				>
					Create New Order
				</PrimaryButton>}
			</Flex>
			{orderData?.length === 0 ? (
				<NoDataComponent />
			) : (
				<CustomTable data={orderData} columns={columns} />
			)}
		</div>
	);
};

export default BulkUpdatePage;

const statusMap = {
	1: "Pending",
	2: "Processing",
	3: "Completed",
	4: "Updated",
};
